<template>
    <b-popover
        id="previewHover"
        ref="previewHover"
        v-if="targetVisible"
        :target="target"
        :delay="{ show: 1000, hide: 500 }"
        :show.sync="show"
        @shown="shown"
        triggers="hover"
        container="app"
        placement="auto"
        custom-class="preview"
        fallback-placement="clockwise"
    >
        <div>
            <header class="card-header pl-3">
                <strong>{{ popTitle }}</strong>
                <a
                    @click="$refs.previewHover.$emit('close')"
                    class="close"
                    style="cursor: pointer;"
                    >&times;</a
                >
            </header>
            <div v-if="loading" class="d-flex justify-content-center">
                <img src="assets/ajax-loader.gif" />
            </div>
            <list v-if="!loading" :data="appointment_data" v-on="$listeners" />
            <br />
            <footer class="card-footer px-2">
                <footer-button :data="appointment_data" v-on="$listeners" />
            </footer>
        </div>
    </b-popover>
</template>
<script>
/* eslint-disable vue/require-default-prop */
import List from "./list.vue";
import FooterButton from "./footer.vue";
import ScheduleHelper from "@/module/schedule/helper";
export default {
    components: {
        List,
        FooterButton
    },
    mixins: [ScheduleHelper],
    props: {
        target: String,
        data: Object,
        showLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            appointment_data: {},
            show: false,
            targetVisible: false
        };
    },
    computed: {
        popTitle() {
            if (this.end && this.start) {
                return (
                    this.start.format("h:mm a") +
                    " - " +
                    this.end.format("h:mm a")
                );
            }
            return "";
        },
        start() {
            return this.appointment_data.start;
        },
        end() {
            return this.appointment_data.end;
        }
    },
    watch: {
        showLoading(value) {
            this.loading = value;
        }
    },
    beforeDestroy() {
        this.$root.$off("eventMouseEnter");
        this.$root.$off("schedule::appointment::modal::list::updated");
    },
    mounted() {
        this.loading = true;
        this.targetVisible =
            this.target && $("#" + this.target).length > 0 ? true : false;

        let self = this;

        this.$root.$on("schedule::appointment::modal::list::updated", function (
            appointmentId
        ) {
            // only update the updated appointment
            if (self.data.id == appointmentId) {
                self.getData(self.data.id, true);
            }
        });
    },
    methods: {
        shown() {
            if (!_.get(this, "appointment_data.start")) {
                this.getData(this.data.id);
            }
        },
        getData(id, updateOnBackground = false) {
            let self = this;
            self._getAppointment(id).then(response => {
                response.start = moment(self.data.start).tz(this._timeZone);
                response.end = moment(self.data.end).tz(this._timeZone);
                self.appointment_data = _.assign(
                    {},
                    self.appointment_data,
                    response
                );

                self.showFooter = true;

                if (
                    _.get(self, "appointment_data.appointmentStatus.id") ==
                    this.APPOINTMENT.STATUS_IN_ROOM
                ) {
                    this.getStatusName();
                }
                self.$nextTick(() => {
                    self.show = updateOnBackground ? false : true;
                });
                self.loading = false;
            });
        },
        async getStatusName() {
            let self = this;
            let response = await this.$http.get(
                process.env.SCHEDULE_SERVICE +
                    "room/" +
                    _.get(
                        self,
                        "appointment_data.appointmentStatus.pivot.room_id"
                    )
            );

            if (_.get(response, "data.response.message.code") == 200) {
                self.appointment_data.appointmentStatus.value =
                    "In " + response.data.response.resources.name;
            }
            return response;
        }
    }
};
</script>
<style lang="scss">
#app .preview.popover {
    min-width: 31.5rem;
    z-index: 1040;

    max-height: none !important;
    .card-footer,
    .card-header {
        margin: -0.5rem -0.75rem;
        padding-top: 0.5rem;
        padding-right: 0.5rem;
        padding-bottom: 0.5rem;
        padding-left: 0.5rem;
    }
    .card-header {
        margin-bottom: 1rem;
        font-size: 0.8rem;
    }
}
</style>
